import React, { useEffect, useState } from 'react';
import Utils from './utils.js';
import { __experimentalInputControl as InputControl } from '@wordpress/components';

function ColorSlug(props) {

    const id = props.idx;
    const [slug, setSlug] = useState();

    return (
        <>
            <InputControl
                label="Color Slug"
                name="slug"
                data-index={props.idx}
                type="text"
                value={ 
                    ( props.inputValue.idx==id && props.inputValue.name != '' ) ? 
                      Utils.kebabCase(props.inputValue.name," ") : props.slug
                }
                onChange={ ( newSlug ) => setSlug( newSlug ) }
                disabled
            />
        </>
    );

}
export default ColorSlug